var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('auction-imgs-overlay', {
    attrs: {
      "imgs": _vm.imgs
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var _vm$imgs$;

        var attrs = _ref.attrs,
            on = _ref.on,
            setIndex = _ref.setIndex;
        return [_c('v-img', _vm._g(_vm._b({
          staticClass: "grey-ef",
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "src": (_vm$imgs$ = _vm.imgs[0]) === null || _vm$imgs$ === void 0 ? void 0 : _vm$imgs$.url,
            "aspect-ratio": 1 / 1,
            "width": "140",
            "contain": ""
          },
          on: {
            "click": function click($event) {
              return setIndex(_vm.imgs[0]);
            }
          }
        }, 'v-img', attrs, false), on))];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }